export default {
  h1: {
    fontWeight: 500,
    fontSize: 55,
    lineHeight: "66px",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "28px !important",
      lineHeight: "40px",
    },
  },
  h2: {
    fontWeight: 500,
    fontSize: 35,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "23px !important",
    },
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "20px !important",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: "30px",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "16px !important",
    },
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "14px !important",
    },
  },

  button: {
    textTransform: "capitalize",
    borderRadius: 27,
  },
  body2: {
    fontSize: 14,
    lineHeight: "25px",
    fontWeight: "400",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "12px !important",
    },
  },
  body1: {
    fontSize: 12,
    lineHeight: "30px",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "10px !important",
    },
  },
  overline: {
    fontWeight: 500,
  },
};
